<template>
  <div class="form-element" :class="{ '-center': isCenter }">
    <button
      :disabled="loading"
      class="form-element__button -little -white"
      :class="classObj"
      @click="action"
      :data-exclude="true"
    >
      <component v-if="icon" :is="`icon-${icon}`" />
      {{ text }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
    },
    theme: {
      type: String,
      default: "blue",
    },
    size: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    isCenter: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classObj: function () {
      let style = [
        this.size ? `-${this.size}` : "",
        this.loading ? `-loading` : "",
        `-${this.theme}`,
      ];

      return style;
    },
    loading: function () {
      return this.$store.getters.isLoading && this.isDisabled;
    },
  },
  methods: {
    action: function () {
      let vm = this;

      if (vm.loading) return;

      vm.$emit("action");
    },
  },
};
</script>